var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "va-row" }, [
    _vm.isAdmin
      ? _c(
          "div",
          { staticClass: "flex md12 xs12" },
          [
            _c("vuestic-widget", [
              _c("div", { staticClass: "va-row" }, [
                _c("div", { staticClass: "flex md4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm",
                      on: { click: _vm.jumpToNewAppPage },
                    },
                    [
                      _c("div", { staticClass: "btn-with-icon-content" }, [
                        _c("i", { staticClass: "ion-md-add-circle ion" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("translate")("basic.button.new")) +
                            "\n            "
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "flex xs12 md12 w-table" },
      [
        _c("vuestic-widget", { attrs: { id: "datagridApp" } }, [
          _c(
            "div",
            { staticClass: "table-responsive" },
            [
              _c("table", { staticClass: "table table-striped" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.apping.appName"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.apping.appId"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.apping.country"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.apping.createDate"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.apping.status"))
                      ),
                    ]),
                    _c("th", { attrs: { align: "right" } }, [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.apping.actions"))
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.applist, function (val, index) {
                    return _c("tr", { key: index }, [
                      _c(
                        "td",
                        {
                          staticClass: "action-color-1",
                          on: {
                            click: function ($event) {
                              return _vm.viewFun(val.app_id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(val.app_name) +
                              "\n              "
                          ),
                        ]
                      ),
                      _c("td", [_vm._v(_vm._s(val.app_id))]),
                      _c("td", [_vm._v(_vm._s(_vm.queryCountry(val.region)))]),
                      _c("td", [_vm._v(_vm._s(val.create_time))]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            val.status == 0
                              ? _vm.$t("statusLabel.disable")
                              : _vm.$t("statusLabel.enable")
                          )
                        ),
                      ]),
                      _c(
                        "td",
                        { attrs: { align: "right" } },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "EditAppInfo",
                                  params: { app_id: val.app_id },
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "action-color-1" }, [
                                _vm._v(_vm._s(_vm.$t("config"))),
                              ]),
                            ]
                          ),
                          _c("span", { staticClass: "action-color-1" }),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ]),
              _vm.isLoading
                ? _c("Spinner", {
                    staticStyle: { margin: "30px auto" },
                    attrs: { size: "small" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "block" }),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }